import React from 'react';
import {MasterLayout} from 'layout';
import { DanhSachDonTheoKy } from 'modules/theo-doi-giam-sat'

export default class DanhSachDonTheoKyPage extends React.Component {

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <DanhSachDonTheoKy/>
      </MasterLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/theo-doi-giam-sat/DanhSachDonTheoKyPage.jsx